import React from 'react';
import { SmartphoneIcon, MonitorIcon, ArrowRightIcon, HeartPulseIcon, DownloadIcon, LogInIcon, ShieldCheckIcon } from 'lucide-react';
export function StickyFooter() {
  return <>
      {/* Main footer */}
      <footer className="w-full bg-text-dark text-white" aria-label="Site footer" data-id="element-576">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-id="element-577">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12" data-id="element-578">
            {/* Brand */}
            <div className="md:col-span-1" data-id="element-579">
              <div className="flex items-center gap-2 mb-4" data-id="element-580">
                <div className="w-9 h-9 bg-medical-blue rounded-xl flex items-center justify-center" data-id="element-581">
                  <HeartPulseIcon className="w-5 h-5 text-white" data-id="element-582" />
                </div>
                <span className="font-bold text-xl" data-id="element-583">
                  Care<span className="text-accent-teal" data-id="element-584">Nomad</span>
                </span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-585">
                Canada's first nurse-led healthcare staffing marketplace.
                Real-time matching for facilities and workers.
              </p>
              <div className="flex flex-col gap-2" data-id="element-586">
                <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-587">
                  <span data-id="element-588">🍁</span>
                  <span data-id="element-589">Made in Canada · Toronto, ON</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium" data-id="element-590">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-accent-teal" data-id="element-591" />
                  <span data-id="element-592">Licensed THA Agency # 12345678</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium" data-id="element-593">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-medical-blue" data-id="element-594" />
                  <span data-id="element-595">100% WSIB Insured</span>
                </div>
              </div>
            </div>

            <div data-id="element-596">
              <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-widest" data-id="element-597">
                Platform
              </h4>
              <ul className="space-y-2.5" data-id="element-598">
                <li data-id="element-599">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-600">
                    Find Workers
                  </a>
                </li>
                <li data-id="element-601">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-602">
                    Post a Shift
                  </a>
                </li>
                <li data-id="element-603">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-604">
                    Live Shift Board
                  </a>
                </li>
                <li data-id="element-605">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-606">
                    Savings Calculator
                  </a>
                </li>
                <li data-id="element-607">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-608">
                    Pricing
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-609">
              <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-widest" data-id="element-610">
                Company
              </h4>
              <ul className="space-y-2.5" data-id="element-611">
                <li data-id="element-612">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-613">
                    About Us
                  </a>
                </li>
                <li data-id="element-614">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-615">
                    Why Nurse-Led
                  </a>
                </li>
                <li data-id="element-616">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-617">
                    Blog
                  </a>
                </li>
                <li data-id="element-618">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-619">
                    Careers
                  </a>
                </li>
                <li data-id="element-620">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-621">
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-622">
              <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-widest" data-id="element-623">
                Support
              </h4>
              <ul className="space-y-2.5" data-id="element-624">
                <li data-id="element-625">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-626">
                    Help Centre
                  </a>
                </li>
                <li data-id="element-627">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-628">
                    FAQ
                  </a>
                </li>
                <li data-id="element-629">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-630">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-631">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-632">
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-633">
                  <a href="tel:+18005551234" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-634">
                    1-800-555-1234
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* App download CTAs */}
          <div className="border-t border-gray-700 pt-10" data-id="element-635">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-636">
              <div data-id="element-637">
                <h3 className="font-bold text-xl mb-1" data-id="element-638">
                  Download the Care Nomad App
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-639">
                  Available for healthcare workers and facility managers
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-640">
                <a href="#" className="flex items-center gap-3 bg-medical-blue hover:bg-medical-blue-dark px-5 py-3.5 rounded-xl transition-all group border border-medical-blue-light" aria-label="Download Employee App" data-id="element-641">
                  <SmartphoneIcon className="w-6 h-6 text-white flex-shrink-0" data-id="element-642" />
                  <div data-id="element-643">
                    <div className="text-white/70 text-xs" data-id="element-644">
                      For Healthcare Workers
                    </div>
                    <div className="text-white font-bold text-sm" data-id="element-645">
                      Employee App
                    </div>
                  </div>
                  <ArrowRightIcon className="w-4 h-4 text-white/60 group-hover:translate-x-0.5 transition-transform" data-id="element-646" />
                </a>
                <a href="#" className="flex items-center gap-3 bg-accent-teal hover:bg-accent-teal-dark px-5 py-3.5 rounded-xl transition-all group" aria-label="Access Client Portal" data-id="element-647">
                  <MonitorIcon className="w-6 h-6 text-white flex-shrink-0" data-id="element-648" />
                  <div data-id="element-649">
                    <div className="text-white/70 text-xs" data-id="element-650">
                      For Facilities & Managers
                    </div>
                    <div className="text-white font-bold text-sm" data-id="element-651">
                      Client Portal
                    </div>
                  </div>
                  <ArrowRightIcon className="w-4 h-4 text-white/60 group-hover:translate-x-0.5 transition-transform" data-id="element-652" />
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-653">
            <p className="text-gray-500 text-xs" data-id="element-654">
              © 2025 Care Nomad Inc. All rights reserved. Registered in
              Ontario, Canada.
            </p>
            <div className="flex items-center gap-4" data-id="element-655">
              <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-656">
                Privacy
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-657">
                Terms
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-658">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Fast Action sticky bar — ALL screen sizes */}
      <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-medical-blue shadow-[0_-4px_24px_rgba(0,85,150,0.15)]" data-id="element-659">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-3" data-id="element-660">
          {/* Left: live indicator (desktop only) */}
          <div className="hidden sm:flex items-center gap-2 flex-shrink-0" data-id="element-661">
            <span className="w-2 h-2 bg-accent-teal rounded-full live-dot" data-id="element-662" />
            <span className="text-sm font-medium text-text-dark" data-id="element-663">
              <span className="font-bold text-medical-blue" data-id="element-664">14 caregivers</span>{' '}
              available now
            </span>
          </div>

          {/* Right: Fast Action buttons */}
          <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-665">
            <a href="#" className="flex-1 sm:flex-none flex items-center justify-center gap-2 bg-medical-blue hover:bg-medical-blue-dark text-white text-sm font-bold px-5 py-3 rounded-xl transition-colors" aria-label="Download the Care Nomad app" data-id="element-666">
              <DownloadIcon className="w-4 h-4" data-id="element-667" />
              Download App
            </a>
            <a href="#" className="flex-1 sm:flex-none flex items-center justify-center gap-2 border-2 border-medical-blue text-medical-blue hover:bg-soft-teal text-sm font-bold px-5 py-3 rounded-xl transition-colors" aria-label="Client login" data-id="element-668">
              <LogInIcon className="w-4 h-4" data-id="element-669" />
              Client Login
            </a>
          </div>
        </div>
      </div>
    </>;
}